import { render } from "./indexComp.vue?vue&type=template&id=5a50850c&scoped=true"
import script from "./indexComp.vue?vue&type=script&lang=js"
export * from "./indexComp.vue?vue&type=script&lang=js"

import "./indexComp.vue?vue&type=style&index=0&id=5a50850c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a50850c"]])

export default __exports__